<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <h6 class="text-muted text-uppercase small mb-2">Corrective Action</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="nearMissDescription">What was the near miss that you observed? Describe it.</label>
                    <app-voice-text-field
                        [(ngModel)]="target.nearMissDescription"
                        name="nearMissDescription"
                        inputId="nearMissDescription"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-check mb-3">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="anyoneInjured"
                        name="anyoneInjured"
                        [(ngModel)]="target.anyoneInjured"
                    />
                    <label class="form-check-label" for="anyoneInjured">Was anyone injured from the incident?</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="damageDone">What damage was done?</label>
                    <app-voice-text-field [(ngModel)]="target.damageDone" name="damageDone" inputId="damageDone" [rows]="2"></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="correctionMade">Correction made — list what you did to correct the hazard you observed.</label>
                    <app-voice-text-field
                        [(ngModel)]="target.correctionMade"
                        name="correctionMade"
                        inputId="correctionMade"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attachments</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingFileSrc(url)"
                            (click)="openExistingFile(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (attachments && attachments.length > 0) {
            <div class="row">
                <label>Files To Upload</label>
                @for (file of attachments; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeAttachment(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="getPendingFileSrc(file)" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Take / Upload Photo</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
